import {Injectable, Provider} from '@angular/core';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, NativeDateAdapter} from '@angular/material/core';

// Datepicker Material en français : affichage et saisie au format JJ/MM/AAAA
@Injectable()
export class FrDateAdapter extends NativeDateAdapter {

    parse(value: any): Date | null {
        if (typeof value === 'string' && value.trim() !== '') {
            const fr = value.trim().match(/^(\d{1,2})[\/.-](\d{1,2})[\/.-](\d{4})$/);
            if (fr) {
                const d = new Date(+fr[3], +fr[2] - 1, +fr[1]);
                return isNaN(d.getTime()) ? null : d;
            }
            const iso = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
            if (iso) {
                const d = new Date(+iso[1], +iso[2] - 1, +iso[3]);
                return isNaN(d.getTime()) ? null : d;
            }
            return null;
        }
        return super.parse(value);
    }

    format(date: Date, displayFormat: any): string {
        if (displayFormat === 'input') {
            const pad = (n: number) => ('0' + n).slice(-2);
            return pad(date.getDate()) + '/' + pad(date.getMonth() + 1) + '/' + date.getFullYear();
        }
        return super.format(date, displayFormat);
    }

    getFirstDayOfWeek(): number {
        return 1;
    }
}

export const FR_DATE_FORMATS = {
    parse: {dateInput: 'input'},
    display: {
        dateInput: 'input',
        monthYearLabel: {year: 'numeric', month: 'short'},
        dateA11yLabel: {year: 'numeric', month: 'long', day: 'numeric'},
        monthYearA11yLabel: {year: 'numeric', month: 'long'},
    },
};

// À déclarer dans les providers d'un module utilisant le datepicker
export const FR_DATE_PROVIDERS: Provider[] = [
    {provide: MAT_DATE_LOCALE, useValue: 'fr-FR'},
    {provide: DateAdapter, useClass: FrDateAdapter},
    {provide: MAT_DATE_FORMATS, useValue: FR_DATE_FORMATS},
];

// Valeur d'un datepicker (Date, ou chaîne ISO déjà au format API) -> "YYYY-MM-DD", '' si vide
export function toApiDate(value: any): string {
    if (!value) {
        return '';
    }
    if (typeof value === 'string') {
        return value.substring(0, 10);
    }
    const d = value as Date;
    if (isNaN(d.getTime())) {
        return '';
    }
    const pad = (n: number) => ('0' + n).slice(-2);
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
}
